import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { ButtonCoreDriver } from '../Button/ButtonCore/ButtonCore.uni.driver';

export interface ToggleButtonUniDriver extends BaseUniDriver {
  isButtonDisabled: ButtonCoreDriver['isButtonDisabled'];
  getSkin: () => Promise<string | null>;
  getShape: () => Promise<string | null>;
  isButtonSelected: () => Promise<boolean>;
  getLabelPlacement: () => Promise<string>;
  getLabelValue: () => Promise<string>;
}
